var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00251 10.1068L1.79601 11.5505C1.76976 11.7325 1.83101 11.9157 1.96051 12.0458C2.09001 12.1758 2.27376 12.2365 2.45576 12.2103L3.89951 12.0038C4.11826 11.9728 4.6666 10.5005 4.6666 10.5005C4.6666 10.5005 4.94193 10.7368 5.05451 10.7723C5.29485 10.8482 5.52876 10.6125 5.60751 10.3733L5.83326 9.33967C5.83326 9.33967 6.16985 9.51001 6.29176 9.53509C6.44693 9.56717 6.59743 9.47151 6.70418 9.36417C6.76659 9.30176 6.8156 9.22476 6.84476 9.13609L6.99993 8.17301C6.99993 8.17301 7.39368 8.28209 7.52843 8.29784C7.68185 8.31534 7.83118 8.23717 7.94085 8.12692L8.60468 7.46367C9.7136 7.82067 10.9806 7.56284 11.8603 6.68317C13.1109 5.43192 13.1109 3.39667 11.8603 2.14601C10.609 0.895341 8.57376 0.895341 7.32309 2.14601C6.44343 3.02567 6.18501 4.29209 6.54259 5.40159L2.16701 9.77659C2.07776 9.86584 2.02001 9.98134 2.00251 10.1068ZM10.7939 3.21234C11.4566 3.87617 11.4566 4.95242 10.7939 5.61684L8.38943 3.21234C9.05384 2.54967 10.1301 2.54967 10.7939 3.21234Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.7911381e9a4f95751226b4c389605fcb.svg";
export { ForwardRef as ReactComponent };